import {
  Popover,
  PopoverTrigger,
  Text,
  PopoverHeader,
  PopoverArrow,
  PopoverCloseButton,
  PopoverContent,
  PopoverBody,
} from "@chakra-ui/react";

const Disclaimer = () => {
  return (
    <Text
      fontWeight="400"
      fontSize="12px"
      lineHeight="150%"
      color="textSecondary"
    >
      Please read{" "}
      <Popover placement="top" trigger="hover">
        <PopoverTrigger>
          <Text display="inline" color="primary" cursor="pointer">
            disclaimer
          </Text>
        </PopoverTrigger>
        <PopoverContent
          color="textSecondary"
          bg="tooltipBackground"
          borderColor="tooltipBackground"
          textAlign="left"
          p="16px"
          borderRadius="8px"
          maxW="290px"
        >
          <PopoverHeader
            fontWeight="600"
            fontSize="20px"
            lineHeight="24px"
            border="0"
            p="0"
          >
            Disclaimer
          </PopoverHeader>
          <PopoverArrow bg="tooltipBackground" />
          <PopoverCloseButton top="12px" />
          <PopoverBody
            fontWeight="400"
            fontSize="12px"
            lineHeight="18px"
            p="8px 0 0"
          >
            APYs are annualized rate of rewards earned through staking matic and
            autocompounding. The staking rewards at any point in time is
            determined by the polygon network and can vary without prior notice.
            Stader cannot and does not guarantee a fixed percentage of rewards.
            Users are encouraged to do their own research and use their
            discretion before participating
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Text>
  );
};

export default Disclaimer;
